import React from 'react'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import { Box } from 'native-base'
import LocalizationContext from '../../context/LocalizationContext'
import Loading from '../../components/basic/Loading'
import CreditList from '../../components/CreditList'
import _ from 'lodash'
import EmptyView from '../../components/basic/EmptyView'

function UserCreditListScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { creditStore, navigation, route } = props
    const { userId } = route.params
    const [isLoading, setIsLoading] = React.useState(true)


    React.useEffect(() => {
        const componentDidMount = async () => {
            try {
                await creditStore.listUserCredit(userId, 0)
            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        }

        componentDidMount()
    }, [navigation])



    const handleOnEndReached = async () => {
        if (toJS(creditStore.memberCreditRecords).length < toJS(creditStore.memberCreditRecordCount)) {
            try {
                await creditStore.listMoreUserCredit(userId, toJS(creditStore.memberCreditRecords).length)
            }
            catch (e) {
                console.log(e)
            }
        }
    }

    if (isLoading) {
        return <Loading />
    }

    if (!toJS(creditStore.memberCreditRecords).length) {
        return <EmptyView t={t}/>
    }

    return (
        <CreditList
            t={t}
            records={toJS(creditStore.memberCreditRecords)}
            onEndReached={() => handleOnEndReached()}
        />
    )
}

export default inject('creditStore')(observer(UserCreditListScreen))